export enum ProspectsTableColumnKeys {
  FirstName = 'first_name',
  LastName = 'last_name',
  Headline = 'headline',
  Company = 'company',
  Location = 'location',
  LinkedinUrl = 'linkedin_url',
  CreationDate = 'creation_date',
  Campaign = 'campaign',
  User = 'user',
  Tags = 'tags',
  Email = 'email',
  Phone = 'phone',
  PersonalEmails = 'personal_emails',
  WorkEmails = 'work_emails',
  EnhancedDate = 'enhanced_date',
}
